import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '../../utils/cn';

export type SpinnerSize = 'small' | 'medium' | 'large' | 'fullscreen';

export interface LoadingSpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: SpinnerSize;
  className?: string;
  iconClassName?: string;
  label?: string;
}

const sizeClasses: Record<Exclude<SpinnerSize, 'fullscreen'>, string> = {
  small: 'h-4 w-4',
  medium: 'h-6 w-6',
  large: 'h-10 w-10',
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  className,
  iconClassName,
  label,
  ...props
}) => {
  if (size === 'fullscreen') {
    return (
      <div className={cn('flex items-center justify-center min-h-[50vh] w-full', className)} {...props}>
        <Loader2 className={cn(sizeClasses.large, 'animate-spin text-purple-600', iconClassName)} />
        {label && <span className="ml-2 text-sm text-muted-foreground">{label}</span>}
      </div>
    );
  }

  const sizeClass = sizeClasses[size];

  return (
    <div className={cn('inline-flex items-center justify-center', className)} {...props}>
      <Loader2 className={cn(sizeClass, 'animate-spin text-purple-600', iconClassName)} />
      {label && <span className="ml-2 text-sm text-muted-foreground">{label}</span>}
    </div>
  );
};

export default LoadingSpinner;
